import React from 'react';
import Icon from '../../../components/AppIcon';

const TournamentSelector = ({ tournaments, selectedTournament, onSelect }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-2">
        Select Tournament
      </label>
      <select
        value={selectedTournament?.id || ''}
        onChange={(e) => {
          const tournament = tournaments?.find(t => t?.id === e?.target?.value);
          onSelect(tournament);
        }}
        className="w-full px-4 py-3 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary">
        <option value="">Choose a tournament...</option>
        {tournaments?.map((tournament) => (
          <option key={tournament?.id} value={tournament?.id}>
            {tournament?.name} ({tournament?.format})
          </option>
        ))}
      </select>
      
      {selectedTournament && (
        <div className="mt-2 p-3 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Calendar" className="w-4 h-4" />
            <span>
              {new Date(selectedTournament?.startDate)?.toLocaleDateString()} - {new Date(selectedTournament?.endDate)?.toLocaleDateString()}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TournamentSelector;